





























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Allocation, Request } from "@/modules/request/Request";
import { Getter } from "vuex-class";
import { BudgetAllocation } from "@/modules/budget/BudgetAllocation";
import { AllocationType } from "@/modules/budget/AllocationType";
import _ from "lodash";
import ThousandNumberInput from "@/components/forms/inputs/ThousandNumberInput.vue";
import { Budget } from "@/modules/budget/Budget";
import moment from "moment";
import Gauge, { GaugePart } from "@/components/miscellaneous/Gauge.vue";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";
import {Topic} from "@/modules/Topic";

interface BudgetRange {
    label: string;
    beginDate: string;
    endDate: string;
}

const components = {
    ThousandNumberInput,
    Gauge,
    LabelValue
};

@Component({components})
export default class RequestAllocations extends Vue {
    private selectedBudgetRangeIndex: number|null = null;
    private selectedBudgets: string[] = [];
    private amountAllocation: object[] = [];
    private realBudgets: Budget[] = [];

    @Prop(String) private allocationsPath!: string;
    @Prop(Boolean) private disabled!: boolean;
    @Prop() private request!: Request;

    @Getter("getBudgets") public budgets!: Budget[];
    @Getter("getBudgetAllocationsByBudget")
    public getBudgetAllocationsByBudget!: (budgetUuid: string) => BudgetAllocation[];
    @Getter("getBudgetAllocations") public allBudgetAllocations!: BudgetAllocation[];
    @Getter("getCurrentFeatures") public currentFeatures!: string[];
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;
    @Getter("getAllTopics") public topics!: (parentUuid: string | null) => Topic[];

    @Watch("request") private changeRequest() {
        this.reinitialize();
    }

    @Watch("budgets")
    private budgetsChanged() {
        this.reinitialize();
    }

    @Watch("allBudgetAllocations")
    private allBudgetAllocationsChanged() {
        this.reinitialize();
    }

    private mounted() {
        this.reinitialize();
    }

    private reinitialize() {
        if (!this.budgets.length) {
            return;
        }
        if (!this.allBudgetAllocations.length) {
            return;
        }
        this.selectedBudgets = [];
        this.amountAllocation = [];
        this.selectedBudgetRangeIndex = null;
        this.guessUsedType();
        this.initBudgetsForRequest();
    }

    private guessUsedType() {
        const budgetAllocation = _.find(this.allBudgetAllocations, (bAlloc: AllocationType) => {
            return _.some(this.request.allocations, (alloc: Allocation) => {
                return bAlloc.uuid === alloc.budgetAllocation.uuid;
            });
        });

        if (null === this.selectedBudgetRangeIndex && 0 < this.budgets.length) {
            const selectedBudget = _.find(this.budgets, (budget: Budget) => {
               return budget.uuid === _.get(budgetAllocation, "budget.uuid", "");
            });

            if (selectedBudget) {
                const foundIndex = _.findIndex(this.budgetRanges, (range: BudgetRange) => {
                    return selectedBudget.beginDate === range.beginDate && selectedBudget.endDate === range.endDate;
                });
                this.selectedBudgetRangeIndex = foundIndex >= 0 ? foundIndex : this.defaultSelectedBudgetRangeIndex;
            } else {
                this.selectedBudgetRangeIndex = this.defaultSelectedBudgetRangeIndex;
            }
        }
    }

    private initBudgetsForRequest() {
        _.forEach(this.allBudgetAllocations, (alloc) => {
            const uuid: string = _.get(alloc, "uuid", "");

            const existingAlloc = _.find(this.request.allocations, (allocation) => {
                return allocation.budgetAllocation.uuid === uuid;
            });

            if (existingAlloc) {
                this.selectedBudgets.push(existingAlloc.budgetAllocation.uuid as string);
            }
            const amount = _.get(existingAlloc, "amount", 0);
            const amountMin = _.get(existingAlloc, "amountMin", 0);
            this.amountAllocation.push({uuid: alloc.uuid, amount, amountMin });
        });
        this.setDefaultSelectedBudget();
        this.retrieveBudgets();
    }

    private get getInfoSelectedBudgets(): any[] {
        const data: any[] = [];
        _.forEach(this.selectedBudgets, (budgetAllocationUuid, idx) => {
            const alloc = _.find(this.allBudgetAllocations, (allocation) => {
                return allocation.uuid === budgetAllocationUuid;
            });
            const labelAlloc = _.get(alloc, "label", "");
            data.push(
                {
                    uuid: budgetAllocationUuid,
                    label: labelAlloc,
                    amount: 0.0,
                }
            );
        });

        if (data.length > 0) {
            return data;
        } else {
            return [];
        }
    }

    private get ready() {
        return this.budgets.length && this.allBudgetAllocations.length;
    }

    private get budgetRanges() {
        const budgetRanges = _.reduce(this.budgets, (ranges: BudgetRange[], budget: Budget) => {
            const alreadyExistingRange = _.some(ranges, (range: BudgetRange) => {
                return range.beginDate === budget.beginDate && range.endDate === budget.endDate;
            });

            if (!alreadyExistingRange) {
                const label = _.invoke(this.$options.filters, "trans", "dateFrom") + " "
                    + _.invoke(this.$options.filters, "date", budget.beginDate) + " "
                    + _.invoke(this.$options.filters, "trans", "dateTo") + " "
                    + _.invoke(this.$options.filters, "date", budget.endDate);
                ranges.push({
                    label,
                    beginDate: budget.beginDate,
                    endDate: budget.endDate,
                });
            }

            return ranges;
        }, []);

        return _.orderBy(budgetRanges, ["beginDate", "endDate"], ["desc", "desc"]);
    }

    private get rangedBudgets() {
        if (null === this.selectedBudgetRangeIndex) {
            return [];
        }
        const selectedBudgetRange = _.get(this.budgetRanges, this.selectedBudgetRangeIndex);

        return _.filter(this.budgets, (budget: Budget) => {
            return budget.beginDate === _.get(selectedBudgetRange, "beginDate", "")
                && budget.endDate === _.get(selectedBudgetRange, "endDate", "");
        });
    }

    private get disabledAllocationBudget() {
        return this.allBudgetsAllocation && this.allBudgetsAllocation.length === 1;
    }

    private get allBudgetsAllocation() {
      return _.reduce(this.rangedBudgets, (budgetAllocation: BudgetAllocation[], rangedBudget: Budget) => {
        budgetAllocation = budgetAllocation.concat(this.getBudgetAllocationsByBudget(rangedBudget.uuid));
        return budgetAllocation;
      }, []).sort((a, b) => a.label.localeCompare(b.label));
    }

    private get canEditAmount(): boolean {
        return !this.disabled
            && (0 < this.selectedBudgets.length)
            ;
    }

    private get defaultSelectedBudgetRangeIndex(): number {
        const defaultIndex = _.findIndex(this.budgetRanges, (range: BudgetRange) => {
            const formattedNow = moment().format("YYYY-MM-DD HH:mm:ss");

            return range.beginDate <= formattedNow && formattedNow <= range.endDate;
        });

        if (0 > defaultIndex) {
            return 0;
        }

        return defaultIndex;
    }

    private updateAmount(amount: number, allocationUuid: string, min: boolean = false) {
        const alloc = _.find(this.amountAllocation, (allocation: Allocation) => {
            return allocation.uuid === allocationUuid;
        }) as Allocation;

        if (min) {
            _.set(alloc, "amountMin", amount);
        } else {
            _.set(alloc, "amount", amount);
        }

        const allocationUpdate = _.find(this.request.allocations, (allocation) => {
            return allocation.budgetAllocation.uuid === allocationUuid;
        });

        let updatedAlloc: Allocation | undefined;
        if (!allocationUpdate) {
            updatedAlloc = {
                budgetAllocation: {
                    uuid: allocationUuid,
                },
                amount: min ? 0 : amount,
                amountMin: min ? amount : null,
                uuid: null,
            };
            this.request.allocations.push(updatedAlloc);
        } else {
            if (min) {
                _.set(allocationUpdate, "amountMin", amount);
            } else {
                _.set(allocationUpdate, "amount", amount);
            }
        }

        this.$emit("change");
    }

    private refreshAmounts(budgetAllocationUuid: string[] | null = null): void {
        const cloneAlloc = _.cloneDeep(this.request.allocations);
        this.$emit("reset-allocations", budgetAllocationUuid);

        this.request.allocations = [];
        _.forEach(this.amountAllocation, (alloc: any, idx) => {
            if (!_.find(this.selectedBudgets, (allocUuid, key) => {
                return allocUuid === alloc.uuid;
            })) {
                alloc.amount = 0.0;
            }
        });

        _.forEach(this.selectedBudgets, (selectedBudget, idx) => {
            const findAllocation = _.find(cloneAlloc, (allocation, key) => {
                return allocation.budgetAllocation.uuid === selectedBudget;
            });

            if (findAllocation) {
                this.request.allocations.push(findAllocation);
            } else {
                const newAlloc = {
                    budgetAllocation: {
                        uuid: selectedBudget,
                    },
                    amount: 0.0,
                    amountMin: null,
                    uuid: null,
                };
                this.request.allocations.push(newAlloc);
            }
        });
    }

    private getSelectedBudgets() {
      return this.hasFeature("MULTI_ALLOC") ? this.selectedBudgets : this.selectedBudgets[0];
    }

    private allocationsChange(budgetAllocationUuid: string[]|string): void {
      this.selectedBudgets = (Array.isArray(budgetAllocationUuid)) ?
          budgetAllocationUuid :
          [budgetAllocationUuid];
      this.refreshAmounts(this.selectedBudgets);
    }

    private setDefaultSelectedBudget(): void {
        if (this.selectedBudgetRangeIndex === null) {
            return;
        }
        if (this.allBudgetsAllocation?.length === 1) {
            this.allocationsChange(this.allBudgetsAllocation[0].uuid);
            return;
        }

        if (this.allBudgetsAllocation.length > 0
            && this.selectedBudgets.length > 0
            && !_.find(this.allBudgetsAllocation, {uuid: this.selectedBudgets[0]})
        ) {
            this.selectedBudgets = [];
            this.refreshAmounts();
        }
    }

    public errorBudget(amount: any): object {
        if (amount.amountMin > amount.amount) {
            return {
                class: "error-border",
                message: _.invoke(this.$options.filters, "trans", "allocationsMinMaxError"),
            };
        }

        const currentSubTopic = _.find(this.topics, (topic: Topic) => {
            return topic.uuid === _.get(this.request, "subtopic.uuid" , "");
        });

        if (amount.amountMin < _.get(currentSubTopic, "minAmount", 0)) {
            return {
                class: "error-border",
                message: _.invoke(this.$options.filters, "trans", "allocationMinNotAllowed") +
                    " (" + _.get(currentSubTopic, "minAmount", 0) + " €)",
            };
        }
        return { };
    }

    private retrieveBudgets(): void {
        this.realBudgets = _.cloneDeep(this.budgets);

        _.forEach(this.request.allocations, (requestAllocation) => {
            const allocationFound = _.find(this.allBudgetAllocations, (allocation) => {
                return allocation.uuid ===  requestAllocation.budgetAllocation.uuid;
            });
            if (allocationFound) {
                const budgetFound = _.find(this.realBudgets, (budget: Budget) => {
                    return budget.uuid === allocationFound.budget.uuid;
                }) as any;

                _.set(
                    budgetFound,
                    "consumedAmountAggregate",
                    (_.get(budgetFound, "consumedAmountAggregate", 0) - requestAllocation.amount)
                );
            }
        });
    }

    private get partsByBudget(): any[] {

        const gauge: any[] = [];
        _.forEach(this.request.allocations, (allocation) => {

            const budgetToFind = _.find(this.allBudgetAllocations, (budgetGetter: Budget) => {
                return budgetGetter.uuid === allocation.budgetAllocation.uuid;
            });

            const budget = _.find(this.realBudgets, (budgets: Budget) => {
                return budgets.uuid === _.get(budgetToFind, "budget.uuid", "");
            });

            const allAllocations = _.filter(this.allBudgetAllocations, (allocationB) => {
                return allocationB.budget.uuid === _.get(budget, "uuid", "");
            });

            let budgetTotal = 0;
            _.forEach(this.request.allocations, (alloca) => {
                if (
                    alloca.uuid !== allocation.uuid &&
                    _.find(allAllocations, (allAllocation: any) => {
                        return alloca.budgetAllocation.uuid === allAllocation.uuid;
                    })
                ) {
                    budgetTotal += alloca.amount;
                }
            });

            const current: number = allocation.amount;
            const consumed: number = _.get(budget, "consumedAmountAggregate", 0) + budgetTotal + current;
            const remaining: number = _.get(budget, "amountIncludingTax", 0) - consumed;

            gauge.push({
                uuid: allocation.budgetAllocation.uuid,
                data:
                    [
                        {
                            amount: consumed,
                            label: _.invoke(this.$options.filters, "trans", "consumedBudget"),
                            color: "seagreen",
                        },
                        {
                            amount: current,
                            label: _.invoke(this.$options.filters, "trans", "currentRequestBudget"),
                            color: "crimson",
                        },
                        {
                            amount: remaining,
                            label: _.invoke(this.$options.filters, "trans", "remainingBudget"),
                            color: "darkgrey",
                        }
                    ]
                }
            );
        });

        return gauge;
    }

    private changeData(): void {
        this.$emit("change");
    }
}
